export const QUERY_DEFAULTS = {
  staleTime: 0,
  gcTime: 5 * 60 * 1000,
  refetchOnMount: 'always' as const,
  refetchOnReconnect: true,
  refetchOnWindowFocus: false,
  retry: 1,
}

export const QUERY_KEYS = {
  products: (status: string, kind: string) =>
    ['products', status, kind] as const,
  storefront: (latitude: number | null, longitude: number | null) =>
    ['storefront', latitude, longitude] as const,
  taxons: (activeOnly: boolean) => ['taxons', activeOnly] as const,
  product: (slug: string) => ['product', slug] as const,
  banners: (activeOnly: boolean, placement: string) =>
    ['banners', activeOnly, placement] as const,
  testimonials: ['testimonials'] as const,
  blogs: ['blogs'] as const,
  blog: (slug: string) => ['blog', slug] as const,
  achievements: ['achievements'] as const,
  orders: ['orders'] as const,
  ordersByStatus: (status?: string) => ['orders', status ?? 'all'] as const,
  addresses: ['addresses'] as const,
  order: (id: string) => ['order', id] as const,
  checkoutProducts: (slugs: string[]) => ['checkout-products', slugs] as const,
  expressCheck: (variantIds: string, latitude: number | null, longitude: number | null) =>
    ['express-check', variantIds, latitude, longitude] as const,
  search: (
    query: string,
    sortBy: string,
    sortOrder: string,
    latitude: number | null,
    longitude: number | null,
    extraFilters?: Record<string, unknown>,
  ) => ['search', query, sortBy, sortOrder, latitude, longitude, extraFilters] as const,
  searchSuggestions: (query: string, latitude: number | null, longitude: number | null) =>
    ['search', 'suggestions', query, latitude, longitude] as const,
  settings: ['settings'] as const,
  locationPincode: (latitude: number | null, longitude: number | null) =>
    ['location-pincode', latitude, longitude] as const,
}
